import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {PluginStore} from '../../services/plugin-store';
import {PluginSelect} from '../../../../../api/models';

@Component({
  selector: 'elcia-plugin-dropdown',
  imports: [Dropdown, TranslatePipe],
  templateUrl: './plugin-dropdown.html',
})
export class PluginDropdown {
  private readonly pluginStore = inject(PluginStore);
  protected readonly plugins = computed<PluginSelect[]>(() => this.pluginStore.plugins());
  control = input.required<FormControl>();
}
